<!-- <div *ngIf="lndUserType" class="row">
    <div class="col-1 header" (click)="home()" style="max-width: fit-content; cursor: pointer;">
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
    </div>
    <div class="col header">
        Employee Documents | {{user}} Portal
    </div>
    <div class="col-1 header menuIcon">
     <i class="fa fa-power-off" aria-hidden="true"></i> comment this

        <span style="font-size:30px;cursor:pointer;float: right;" (click)="allLink.openNav()">&#9776; </span>

    </div>


</div> -->
<span *ngIf="lndUserType">
<app-header-global></app-header-global>
</span>

<div class="row allcontent">
    <div [ngClass]="sidebarCollapsed ? 'col-sm-1' : 'col-sm-2'">
        <app-side-overlay-menu></app-side-overlay-menu>
    </div>
    <div [ngClass]="sidebarCollapsed ? 'col-sm-11' : 'col-sm-10'" class="contentsection">
        <div *ngIf="lndUserType" class="row p1rem fix_header" >
            <p class="custom_heading">Documents</p>
            <!-- <div class="col user-header">
                Hello {{name}}!
            </div>
         -->
        </div>
        
        <div class="wrapper margin__top">
        <div *ngFor="let document of documents">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <div class="row">
                                        <div class="col text-heading">
                                            <strong>{{document.title}} </strong>  
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col text-decor">
                                            {{document.description}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="row">
                                        <div class="col p5 view-btn">
                                            <button type="button" class="btn btn-outline-primary" (click)="viewDownloadPdf(document.file)">Download</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        
        </div>
    </div>
</div>


